export default {
  'account_info': 'Account Information',
  'other_account': 'Trading Account Application',
  'account_application': 'Futures Account Application',
  'records': 'Funds Record',
  'children_account': 'Bank Sub-Account',
  'setting': 'Setting',
  'deposit': 'Deposit Record',
  'depositTitle': 'Deposit',
  'withdrawal': 'Withdrawal Record',
  'withdrawalTitle': 'Withdraw',
  'transfer': 'Internal Transfer Record',
  'transferTitle': 'Internal Transfer',
  'trade_product': 'Structured Products Application',
  'open_trades': 'Open Trades',
  'close_trades': 'Close Trades',
  'download': 'Platform Download',
  'table-download': 'File Download',
  'trade_recordes': 'Trading Record',
  'exchange': 'Foreign Exchange',
  'quotes': 'Real Time Quote Application',
  'bonds': 'Debt Application',
  'breadcrumb': {
    'home': 'Home Page',
    'my_account': 'My Account',
    'add-hkCard': 'Add Hong Kong Bank Card',
    'account_info': 'Account Information',
    'bonds': 'Debt Application',
    'other_account': 'Trading Account Application',
    'account_application': 'Account Application',
    'trade_product': 'Appplication to trade structured products',
    'records': 'Funds Record',
    'deposit': 'Deposit Record',
    'depositTitle': 'Deposit',
    'withdrawal': 'Withdrawal Record',
    'withdrawalTitle': 'Withdraw',
    'transfer': 'Internal Transfer Record',
    'transferTitle': 'Internal Transfer',
    'children_account': 'Bank Sub-Account',
    'setting': 'Setting',
    'open_trades': 'Open Trades',
    'close_trades': 'Close Trades',
    'online_bank_deposit': 'e-Banking Transfer',
    'atm_transfer_deposit': 'ATM Transfer',
    'bank_transfer_deposit': 'Bank Counter Transfer',
    'cheque_deposit': 'Cheque Deposit',
    'fps_deposit': 'FPS Deposit',
    'sub_account_deposit': 'Sub-Account Deposit',
    'upload_deposit_reciept': 'Upload Deposit Receipt',
    'download': 'Platform Download',
    'table-download': 'File Download',
    'trade_recordes': 'Trading Record',
    'exchange': 'Foreign Exchange',
    'quotes': 'Real Time Quote Application',
    'exchangeRecords': 'Foreign Exchange Record'
  }
}
